export const DOC_TYPE_REF = 'DOC_TYPE_REF';